<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button
          v-if="backRole('CT_1')"
          type="primary"
          @click="startCreate()"
          size="mini"
          >新建合同</el-button
        >
      </div>
      <label class="label-name">所属公司：</label>
      <el-select
        size="small"
        :disabled="noSelectOrganization"
        class="organization-select"
        v-model="form.depId"
        placeholder="请选择所属公司"
      >
        <el-option
          v-for="item in organizationListData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="list-title" style="padding: 5px 10px 8px; background: #f8f8f8">
      <!-- 条件搜索 -->
      <h3
        class="title"
        style="float: none; border-bottom: 1px #ccc solid; margin-bottom: 5px"
      >
        条件搜索
        <span class="tip" style="font-size: 12px"
          >（搜索条件为选填, 然后点击搜索按钮进行搜索）</span
        >
      </h3>
      <section style="font-size: 12px">
        <div class="filter-item" style="margin-bottom: 5px">
          <label>合同状态：</label>
          <el-select size="mini" v-model="filterStatus" placeholder="请选择">
            <el-option
              v-for="item in statusArr"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <label class="label-name ml5px">合同编号：</label>
          <span style="width: 210px; display: inline-block">
            <el-input size="mini" type="number" v-model="form.htbh"></el-input>
          </span>

          <label class="label-name ml5px">项目负责人：</label>
          <span style="width: 160px; display: inline-block">
            <el-input size="mini" type="" v-model="form.creator"></el-input>
          </span>
        </div>
        <div class="filter-item" style="margin-bottom: 5px">
          <a
            style="float: right"
            :href="
              baseURL +
              '/contract/list/download?depId=' +
              form.depId +
              '&creator=' +
              form.creator +
              '&htbh=' +
              form.htbh +
              '&isBigContract=' +
              (form.isBig ? 1 : '') +
              '&name=' +
              form.name +
              '&status=' +
              form.status
            "
            target="_blank"
          >
            <el-button type="primary" size="mini">合同列表下载</el-button>
          </a>

          <label class="label-name ml5px">合同名称：</label>
          <span style="width: 420px; display: inline-block">
            <el-input size="mini" type="" v-model="form.name"></el-input>
          </span>

          <el-checkbox style="margin: 0 15px" v-model="form.isBig"
            >重大合同</el-checkbox
          >

          <el-button
            type="success"
            @click="getFilterData()"
            style="margin-left: 5px"
            size="mini"
            >搜索筛选结果</el-button
          >
          <el-button
            type="primary"
            @click="resetFilterData()"
            style="margin-left: 5px"
            size="mini"
            >重置</el-button
          >
        </div>
      </section>
    </div>

    <el-table
      :data="paginationData"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="htbh" label="合同编号" width="100px">
      </el-table-column>
      <el-table-column label="合同名称">
        <template slot-scope="scope">
          <span v-html="getTypeName(scope.row.type)"></span>
          <router-link
            :class="scope.row.status == '已废弃' ? 'table-link-delete' : ''"
            :to="'/Contract/Detail/' + scope.row.id"
            class="link"
            target="_blank"
            >{{ scope.row.name }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="120px">
      </el-table-column>

      <!-- <el-table-column prop="departmentVO.name" label="所属公司" width="180px">
      </el-table-column> -->
      <el-table-column prop="htjk" label="合同金额(元)" width="90px">
      </el-table-column>
      <!-- <el-table-column label="合同类型" width="100px">
        <template slot-scope="scope">
          {{ contractTypeName[scope.row.type] }}
        </template>
      </el-table-column> -->
      <el-table-column prop="status" label="状态" width="80px">
      </el-table-column>

      <el-table-column label="合同负责人" width="150px">
        <template slot-scope="scope">
          <user-info :userData="scope.row.leader"></user-info>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="createTime" label="创建时间" width="120px">
      </el-table-column> -->

      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <router-link target="_blank" :to="'/Contract/Detail/' + scope.row.id">
            <el-button plain size="mini">详情</el-button>
          </router-link>
          <el-button
            v-if="
              scope.row.status == '新建完成' &&
              scope.row.leader.id == userData.id
            "
            type="danger"
            plain
            size="mini"
            @click="contractDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-left: -5px"
      v-if="pageTotal > form.pageSize"
      class="list-pagination"
      background
      :page-size="form.pageSize"
      :pager-count="9"
      :current-page="form.page + 1"
      layout="pager"
      :total="pageTotal"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Role from "@/Mixins/role";
import UserInfo from "@/components/UserInfo";
export default {
  components: {
    UserInfo,
  },
  mixins: [Role],
  computed: {
    ...mapState({
      organization: (state) => state.main.organization,
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      baseURL: axios.defaults.baseURL,

      organizationListData: [],
      noSelectOrganization: true,
      // depId: '',

      contractTypeName: ["独立合同", "工程施工合同", "子项目合同"],

      // projectListStatus: false,
      // projectDepId: "",
      // projectKey: "",
      // projectFilterList: [],
      // projectList: [],
      // projects: [],
      form: {
        creator: "",
        depId: "",
        htbh: "",
        name: "",
        status: "",
        page: 0,
        pageSize: 20,
        isBigContract: "",
        isBig: false,
      },

      // filterKey: "",
      filterStatus: "全部",
      // filterType: "全部",
      statusArr: [
        "全部",
        "新建完成",
        "招标中",
        "招标完成",
        "签订中",
        "签订完成",
        "实施中",
        "验收完成",
      ],
      // typeArr: ['全部', '合同', '工程合同', '子项目'],

      // 列表
      loading: true,
      pageTotal: 0,
      listData: [],
      filterData: [],
      paginationData: [],

      // typeName
      typeName: ["合同", "工程合同", "子项目"],
    };
  },
  mounted() {
    if (!this.userData) {
      return false;
    }

    // this.organizationListData.push({
    //   id: 0,
    //   name: "集团所有公司",
    //   depId: 0
    // })
    let _or =
      this.organization.length > 0 ? this.organization[0].childDepts : [];
    this.organizationListData = this.organizationListData.concat(_or);

    this.projectDepId = this.form.depId =
      this.userData.secDepIds.split(",")[0] / 1;

    if (this.form.depId == "7" || this.backRole("SYSTEM_1")) {
      this.noSelectOrganization = false;
      // this.form.depId = 0
    }

    // 获取列表
    this.getLists();
  },
  methods: {
    getTypeName(type) {
      return (
        '<span class="approval-type at' +
        type +
        '">' +
        this.typeName[type] +
        "</span>"
      );
    },

    contractDelete(row) {
      this.$confirm("此操作将永久删除该合同, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ajax.post(
            "/contract/del",
            {
              contractId: row.id,
            },
            (res) => {
              this.$message.error("删除合同成功");
              // 重新获取列表
              this.getLists();
            }
          );
        })
        .catch(() => {});
    },
    // EditMeeting(row) {
    //   this.$router.push('/Meeting/Edit/' + row.id)
    // },
    startCreate() {
      this.$router.push("/Contract/Create");
    },
    // 当前页
    handleCurrentChange(val) {
      this.form.page = val - 1;
      this.getLists();
    },

    // 重置
    resetFilterData() {
      this.form.creator = "";
      this.form.htbh = "";
      this.form.name = "";
      this.form.status = "";
      this.form.isBigContract = "";
      this.form.isBig = false;
      this.form.page = 0;
      this.form.pageSize = 20;
      this.filterStatus = "全部";

      // 获取符合条件的列表
      this.getLists();
    },
    // 搜索筛选新闻数据
    getFilterData() {
      this.form.page = 0;
      this.form.status = this.filterStatus == "全部" ? "" : this.filterStatus;

      this.getLists();
    },
    // 分页筛选数据
    getPaginationData() {
      this.paginationData = this.filterData;
    },
    // 获取列表
    getLists() {
      this.loading = true;
      this.form.isBigContract = this.form.isBig ? 1 : "";
      ajax.get("/contract/list", this.form, (res) => {
        this.loading = false;

        this.filterData = this.listData = res.vo.list;
        this.pageTotal = res.vo.size;
        this.getPaginationData();
      });
    },
  },
  watch: {
    "form.depId"() {
      this.getLists();
    },
    // 'filterType'() {
    //   this.getFilterData()
    // },
    // 'filterStatus'() {
    //   this.getFilterData()
    // },
    // 'filterKey'() {
    //   this.getFilterData()
    // },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/contract/list.vue